import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'app-version-name-info-dialog',
    templateUrl: './version-name-info-dialog.component.html',
    styleUrls: ['./version-name-info-dialog.component.css'],
    standalone: false,
})
export class VersionNameInfoDialogComponent {
    constructor(
        @Inject(MAT_DIALOG_DATA)
        public data: {
            versionName: string;
        },
        private dialogRef: MatDialogRef<VersionNameInfoDialogComponent>
    ) {}

    close() {
        this.dialogRef.close();
    }
}
